export const closeModal = () =>{
   document.getElementById('subscribe').style.display='none'      
    

}